module.exports = {"common":{"year":"rft.date","volume":"rft.volume","issue":"rft.issue","pages":"rft.pages"},"book":{"title":"rft.btitle","series":"rft.series","publisher":"rft.pub"},"journal":{"title":"rft.atitle","source":"rft.jtitle"},"default":{"title":"rft.atitle"}}


//////////////////
// WEBPACK FOOTER
// ./src/universal/ui/utils/open-url/field-map.json
// module id = 1062
// module chunks = 1